// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { helpDialogPlugin, deprecatedOpenHelpCommand } from '@atlaskit/editor-plugin-help-dialog';
export type {
	HelpDialogPlugin,
	HelpDialogSharedState,
	HelpDialogPluginOptions,
	HelpDialogDependencies,
} from '@atlaskit/editor-plugin-help-dialog';
